var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    staticClass: "d-flex align-center list-widget",
    attrs: {
      "outlined": ""
    }
  }, 'v-card', {
    width: _vm.width,
    height: _vm.height,
    minWidth: _vm.minWidth,
    maxWidth: _vm.maxWidth
  }, false), [_c('v-card-text', {
    staticClass: "py-0 text-caption"
  }, [_c('v-row', {
    staticClass: "ma-n1",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.title) + ":")])]), _c('v-col', {
    staticClass: "pa-1 list-widget__body"
  }, [_vm._t("default", null, null, {
    attrs: {
      class: 'list-widget__body__input text-caption font-weight-bold'
    }
  })], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }